import { NotificationType, NotificationTypeText } from 'types/notification'

const notificationTypeText = {
  request: {
    isPrefix: false,
    isSuffix: true,
    text: 'requested to join',
  },
  like: {
    isPrefix: false,
    isSuffix: true,
    text: 'liked your post',
  },
  highFive: {
    isPrefix: false,
    isSuffix: true,
    text: 'high fived your post',
  },
  comment: {
    isPrefix: false,
    isSuffix: false,
    text: 'commented on your post',
  },
  commentOnCommentedPost: {
    isPrefix: false,
    isSuffix: false,
    text: 'commented on a post you commented on',
  },
  completion: {
    isPrefix: false,
    isSuffix: true,
    text: 'completed your workout',
  },
  accepted: {
    isPrefix: false,
    isSuffix: false,
    text: 'into your Group - ',
    prefixText: 'You just accepted ',
  },
  friend: {
    isPrefix: true,
    isSuffix: false,
    text: 'You are now friends with',
  },
  follow: {
    isPrefix: false,
    isSuffix: true,
    text: 'started following you',
  },
  add: {
    isPrefix: true,
    isSuffix: false,
    text: 'You were just accepted into',
  },
}

export const getTextForNotificationType = (
  type: NotificationType | 'commentOnCommentedPost',
): NotificationTypeText => {
  return notificationTypeText[type]
}
